import { defineMessages } from 'react-intl';

import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const messages = defineMessages({
  fixed: {
    id: 'Fixed',
    defaultMessage: 'Fixed',
  },
});
export const fixedStyleSchema = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });

  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'fixed',
  ];
  schema.properties.styles.schema.properties.fixed = {
    title: intl.formatMessage(messages.fixed),
    type: 'boolean',
    default: false,
  };

  return schema;
};
